export interface Review {
  id: string;
  name: string;
  username: string;
  avatar: string;
  content: string;
  rating: number;
}

export const reviews: Review[] = [
  {
    id: 'review-1',
    name: '吃瓜群众小王',
    username: '@chigua_xiaowang',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20young%20Chinese%20person%2C%20flat%20illustration%20style%2C%20warm%20coral%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-1&orientation=squarish',
    content: '自从关注了52吃瓜网，我再也不怕错过任何大瓜了！每天的推送都超级及时，料也很足，真的是吃瓜人的天堂。已经推荐给身边所有爱吃瓜的朋友了！',
    rating: 5,
  },
  {
    id: 'review-2',
    name: '八卦研究所',
    username: '@bagua_lab',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20person%2C%20flat%20illustration%20style%2C%20lime%20green%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-2&orientation=squarish',
    content: '做八卦内容这么多年，52吃瓜网是我见过更新最快、料最准的平台。虽然偶尔标题有点夸张，但内容确实有料，比那些只会编故事的营销号强太多了。',
    rating: 4,
  },
  {
    id: 'review-3',
    name: '深夜吃瓜人',
    username: '@late_night_melon',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20young%20person%2C%20flat%20illustration%20style%2C%20warm%20amber%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-3&orientation=squarish',
    content: '每天晚上睡前必刷52吃瓜网，已经成了习惯了。APP也特别好用，推送及时，界面清爽。唯一的遗憾就是有时候瓜不够多，看不够啊！',
    rating: 5,
  },
  {
    id: 'review-4',
    name: '理性吃瓜协会',
    username: '@rational_eater',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20mature%20person%2C%20flat%20illustration%20style%2C%20dark%20gray%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-4&orientation=squarish',
    content: '作为一个喜欢理性分析八卦的人，52吃瓜网的内容质量让我挺满意的。不是一味地煽动情绪，有些深度扒皮的文章写得确实有水平。希望能继续保持这个质量。',
    rating: 5,
  },
  {
    id: 'review-5',
    name: '追瓜少女小美',
    username: '@mei_mei_chigua',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20young%20girl%2C%20flat%20illustration%20style%2C%20pink%20coral%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-5&orientation=squarish',
    content: '我太爱52吃瓜网了！每天的瓜都又大又甜，编辑的文案也超有意思。课间和室友一起看，笑到停不下来。吃瓜让我们的友谊更加牢固哈哈哈！',
    rating: 5,
  },
  {
    id: 'review-6',
    name: '隔壁老李头',
    username: '@old_lee_nextdoor',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20middle-aged%20person%2C%20flat%20illustration%20style%2C%20teal%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-review-6&orientation=squarish',
    content: '本来对这种八卦网站没什么兴趣，被女儿安利了之后才发现真香。现在每天午休都要刷一下看看有什么新鲜事，跟年轻同事也有了更多共同话题。',
    rating: 4,
  },
];

export const aboutReviews: Review[] = [
  {
    id: 'about-review-1',
    name: '娱乐圈资深记者王老师',
    username: '@reporter_wang',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20professional%20journalist%2C%20flat%20illustration%20style%2C%20dark%20navy%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-about-1&orientation=squarish',
    content: '从业二十年，见证过无数娱乐媒体的兴衰。52吃瓜网是近年来少有的能把娱乐性和真实性平衡得如此出色的平台。作为行业前辈，我真心为他们的专业态度点赞。',
    rating: 5,
  },
  {
    id: 'about-review-2',
    name: '自媒体人小李',
    username: '@creator_li',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20content%20creator%2C%20flat%20illustration%20style%2C%20vibrant%20orange%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-about-2&orientation=squarish',
    content: '作为一个自媒体人，52吃瓜网是我每天必看的资讯源之一。他们的选题角度和内容深度在同类平台中确实算是佼佼者，很多时候都能给我带来创作灵感。',
    rating: 5,
  },
  {
    id: 'about-review-3',
    name: '普通吃瓜群众阿芳',
    username: '@afang_daily',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20avatar%20portrait%20of%20a%20friendly%20woman%2C%20flat%20illustration%20style%2C%20soft%20lavender%20background%2C%20clean%20simple%20design%2C%20modern%20profile%20picture&width=100&height=100&seq=avatar-about-3&orientation=squarish',
    content: '感谢52吃瓜网让我的生活多了这么多乐趣！从去年开始关注，到现在已经成了忠实粉丝。每次看到大瓜，第一时间就想到要来52吃瓜网看看有没有更详细的爆料。',
    rating: 5,
  },
];

export const stats = [
  { value: '500万+', label: '月活跃用户' },
  { value: '3000+', label: '独家爆料文章' },
  { value: '98%', label: '用户满意度' },
  { value: '200+', label: '合作媒体伙伴' },
];